module.exports = __webpack_public_path__ + "img/banner.80ec1bfa.png";